// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MenuJs = require("./Menu.js").default;

var make = MenuJs;

exports.make = make;
/* make Not a pure module */
